import { render } from "./template.2283.vue?vue&type=template&id=5c7c3df4&scoped=true"
import script from "./template.2283.vue?vue&type=script&lang=js"
export * from "./template.2283.vue?vue&type=script&lang=js"

import "./template.2283.vue?vue&type=style&index=0&id=5c7c3df4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7c3df4"]])

export default __exports__